import { render } from "./brand.vue?vue&type=template&id=e7a91628&scoped=true"
import script from "./brand.vue?vue&type=script&lang=js"
export * from "./brand.vue?vue&type=script&lang=js"

import "./brand.vue?vue&type=style&index=0&id=e7a91628&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e7a91628"

export default script